import { Injector, NgModule } from '@angular/core';
import { Http, RequestOptions } from '@angular/http';
import { AuthHttp, AuthConfig } from 'angular2-jwt';
import { SessionStorageService } from '../services/session-storage.service';
import { environment } from '../environments/environment';

export function authHttpServiceFactory(http: Http, options: RequestOptions, session: SessionStorageService) {
  return new AuthHttp(new AuthConfig({
    tokenName: environment.token,
    tokenGetter: (() => session.getToken()),
    globalHeaders: [{'Content-Type':'application/json'}],
    noJwtError: true
  }), http, options);
}

@NgModule({
  providers: [
    {
      provide: AuthHttp,
      useFactory: authHttpServiceFactory,
      deps: [Http, RequestOptions, SessionStorageService]
    }
  ]
})
export class AuthHttpModule {
}


// WEBPACK FOOTER //
// ./src/services/auth-http.module.ts